// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"b5b15251","167":"d4d3c855"}[chunkId] + ".chunk.js";
};